import gql from 'graphql-tag';

export default gql`
  mutation CreateProduct($input: ProductCreateInput!) {
    createProduct(data: $input) {
      createdAt
      id
      updatedAt
      name
      description
      price
      capacity
      event {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/CreateProduct.ts